"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleType = void 0;
var VehicleType;
(function (VehicleType) {
    VehicleType["CAR"] = "Personbil";
    VehicleType["VAN"] = "Varebil";
})(VehicleType = exports.VehicleType || (exports.VehicleType = {}));
//# sourceMappingURL=vehicleType.js.map